import React from "react";
import { Modal, Button } from "react-bootstrap";
import CustomIcons from "../../../icons/kIcons.component";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

export default function MoreDetails(props) {
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
    const isLoggedIn = Boolean(
    props?.state?.payload ||
    localStorage.getItem("token") ||
    localStorage.getItem("payload") ||
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("payload")
  );
  const handleNav = (d, a) => {
    if (a === "live") {
      window.open(`${result}/${d}`, "_blank");
    } else {
      if (d.startsWith("https://")) {
        window.open(`${d}`, "_blank");
      } else {
        window.open(`https://${d}`, "_blank");
      }
    }
  };
  return (
    <Modal
      {...props}
      show={props.open}
      onHide={(e) => props.handleClose()}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title id="contained-modal-title-vcenter">
          {props.data.company_name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          {/* Header summary */}
          <div className="row align-items-center mb-3">
            <div className="col-auto">
              {props?.data?.logo ? (
                <div className="comp-item-logo">
                  <img
                    className="comp-item-img-logo"
                    alt=""
                    src={`${result}/${props?.data?.logo}`}
                  />
                </div>
              ) : (
                <div className="comp-item-logo" style={{ minWidth: "120px" }}>
                  {props?.data?.company_name?.substring(0, 1)}
                </div>
              )}
            </div>
            <div className="col">
              <div className="comp-item-person-name mb-1">
                {props.data.person_name}
              </div>

              <div className="d-flex align-items-center mb-1">
                <CustomIcons iconName="user" iconClass="comp-item-data-icons" />
                <div className="text-break">{props.data.person_designation}</div>
              </div>
              <div className="d-flex align-items-center mb-1">
                <CustomIcons iconName="mail" iconClass="comp-item-data-icons" />
                <div className="text-break">{props.data.email}</div>
              </div>
              {isLoggedIn && (
              <div className="d-flex align-items-center mb-1">
                <CustomIcons iconName="phone" iconClass="comp-item-data-icons" />
                <div className="text-break">{props.data.phone_no}</div>
              </div>
              )}
              {props?.data?.site_link && (
                <div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                  <CustomIcons iconName="globe" iconClass="comp-item-data-icons" />
                  <div
                    className="text-break"
                    onClick={() => handleNav(props?.data?.site_link)}
                  >
                    {props?.data?.site_link}
                  </div>
                </div>
              )}
            </div>
            <div className="col-auto">
              {props.data.ex_man_power && props.data.ex_man_power !== "null" && (
                <span className="chip">Employees: {props.data.ex_man_power}</span>
              )}
            </div>
          </div>

          {/* Domains & Actions */}
          <div className="row align-items-center mb-3">
            <div className="col">
              <div className="comp-item-dom-cont">
                {props?.data?.any_other_domain && (
                  <span className="chip">#{props?.data?.any_other_domain}</span>
                )}
                {props?.data?.domain_types?.map((dom, i) => (
                  <span key={`${dom.domain_name}-${i}`} className="chip">#{dom.domain_name}</span>
                ))}
              </div>
            </div>
            {props?.data?.upload_proposal && (
              <div className="col-auto">
                <Button
                  className="bg-primary"
                  onClick={() => handleNav(props?.data?.upload_proposal, "live")}
                >
                  Brochure
                </Button>
              </div>
            )}
          </div>

          {/* Product Profiles */}
          <div className="comp-item-product-prof-cont">
            <b>Product Profile</b>
            <hr />
            {props.data.product_profiles?.map((produ, index) => (
              <div key={produ.id || index} className="mb-3">
                <div className="comp-item-prod-prof-title">
                  {index + 1}.&nbsp;{produ.product_name}
                </div>
                <div className="comp-item-prod-prof-desc">
                  <div>{ReactHtmlParser(produ.product_desc)}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Abstract (conditional) */}
          {props.india && (
            <div className="comp-item-product-prof-cont">
              <b>Abstract Company Profile</b>
              <hr />
              <div>
                <div className="comp-item-prod-prof-title">
                  {props?.data?.abstract_project_proposal}
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={(e) => props.handleClose()}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
